module.exports = __webpack_public_path__ + "static/mentor-31c80b3e36fd6d6ccd43274d4ad38e84.svg";